<template>
  <DeviceSetupSection>
    <template v-slot:left>
      <PageContainer
        :class="$style.container"
      >
        <template v-slot:body>
          <Container>
            <HeadingLarge>
              {{ selectedInstall.header }}
            </HeadingLarge>
            <div v-if="!onLastStep">
              <ParagraphBody>
                {{ selectedInstall.subheader }}
              </ParagraphBody>
              <div
                :class="$style.section"
                @click="triggerCopyWellClickedEvent(copyWell.label)"
              >
                <CopyWell
                  isFullWidth
                  :label="copyWell.label"
                  multiLine
                  :value="copyWell.content"
                />
              </div>
              <div
                v-if="selectedInstall.value === installTypes.terminal"
                :class="$style.section"
              >
                <CompatibilityNotes
                  :compatibilityNotes="compatibilityNotes"
                />
              </div>
            </div>
            <DeviceSetupSuccess
              v-else
              :showInstallerNotes="true"
            />
          </Container>
        </template>
        <template v-slot:footer>
          <Container>
            <ButtonGroupSave
              :isFullWidth="false"
              :primaryButtonProps="primaryButtonProps"
              :secondaryButtonProps="secondaryButtonProps"
              @primaryAction="handleNext"
              @secondaryAction="secondaryAction"
            />
          </Container>
        </template>
      </PageContainer>
    </template>
    <template v-slot:right>
      <div
        :class="[$style.image, $style.center]"
        :style="{ backgroundImage }"
      />
    </template>
  </DeviceSetupSection>
</template>

<script>
import {
  ButtonGroupSave,
  Container,
  CopyWell,
  HeadingLarge,
  PageContainer,
  ParagraphBody,
} from '@jumpcloud/ui-components';
import { SystemCompatibilityConsts } from 'client/util/Constants';
import {
  eventLocations,
  eventProperties,
} from 'client/GrowthEngineering/utilities/GrowthConstants';
import { guidedSetupInstallTypes } from 'client/Discover/components/GuidedSetup/GuidedSetupSettings';
import CompatibilityNotes from 'client/systems/CompatibilityNotes.vue';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import DeviceSetupSection from 'client/Discover/components/GuidedSetup/DeviceSetupSection.vue';
import DeviceSetupSuccess from 'client/Discover/components/GuidedSetup/DeviceSetupSuccess.vue';
import GuidedSetupMixin from 'client/Discover/components/GuidedSetup/mixins/GuidedSetupMixin';

const {
  description,
  location,
  section,
} = eventProperties;

export default {
  name: 'LinuxSetup',

  components: {
    ButtonGroupSave,
    CompatibilityNotes,
    Container,
    CopyWell,
    DeviceSetupSection,
    DeviceSetupSuccess,
    PageContainer,
    HeadingLarge,
    ParagraphBody,
  },

  mixins: [
    CreateSystemMixin,
    GuidedSetupMixin,
  ],

  data: () => ({
    installTypes: guidedSetupInstallTypes,
    lastStep: 2,
  }),

  computed: {
    compatibilityNotes() {
      return {
        header: 'Supported Operating Systems',
        kbLink: this.kbLink,
        text: SystemCompatibilityConsts.linux,
      };
    },

    copyWell() {
      let copyWell;

      switch (this.selectedInstall.value) {
        case guidedSetupInstallTypes.puppet:
          copyWell = this.copyWellPuppet;
          break;
        case guidedSetupInstallTypes.chef:
          copyWell = this.copyWellChef;
          break;
        default:
          copyWell = this.copyWellLinux;
      }

      return copyWell;
    },
  },

  methods: {
    triggerCopyWellClickedEvent(copyWellLabel) {
      this.$options.EventHelper.triggerCopyWellClicked({
        [description]: `${copyWellLabel} copy well clicked`,
        [location]: eventLocations.immersiveOnboarding,
        [section]: `${this.settings.label} - ${this.selectedInstall.header} - step ${this.currentStep}`,
      });
    },
  },
};
</script>

<style scoped module>
@import './css/guided-setup.css';

.section {
  padding: var(--jc-spacer-large) 0;
}

.note {
  padding-bottom: var(--jc-spacer-large);
}
</style>
